import { render, staticRenderFns } from "./AccidentDetails.vue?vue&type=template&id=325518cd&scoped=true"
import script from "./AccidentDetails.vue?vue&type=script&lang=ts"
export * from "./AccidentDetails.vue?vue&type=script&lang=ts"
import style0 from "./AccidentDetails.vue?vue&type=style&index=0&id=325518cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325518cd",
  null
  
)

export default component.exports